import { Box, VStack, Stack, Divider } from "@chakra-ui/react";
import { Paragraph03, Paragraph04 } from "~/components/Texts";
import Link from "next/link";

export default function Footer({ orderId, shop }) {
  return (
    <VStack w="100%">
      <Divider
        w="100%"
        h="2px"
        backgroundColor={shop.theme.colors.background.strong}
      />

      <Stack
        direction={{ base: "column", md: "row" }}
        w="100%"
        align={{ base: "flex-start", md: "flex-end" }}
        spacing={{ base: "2", md: "4" }}
      >
        <Paragraph03>
          Esta tienda vende por internet con
          <b>
            {" "}
            <Link href="https://www.shopstory.io">
              <a>Shop Story</a>
            </Link>
          </b>
        </Paragraph03>
        <Box flex="1" />
        <VStack align="flex-start">
          <Paragraph04>{`ID Tienda: ${shop.id}`}</Paragraph04>
          <Paragraph04>{`ID Orden: ${orderId}`}</Paragraph04>
        </VStack>
      </Stack>
    </VStack>
  );
}
